import { PartialTranslation } from '../translations';

export const fa: PartialTranslation = {
  newChat: 'گفتگوی جدید',
  search: 'جستجو',
  user: 'کاربر',
  settings: 'تنظیمات',
  language: 'زبان',
  getHelp: 'دریافت کمک',
  viewAllPlans: 'مشاهده همه طرح‌ها',
  learnMore: 'بیشتر بدانید',
  logOut: 'خروج',
  chooseLanguage: 'انتخاب زبان',
  chooseYourPreferredLanguage: 'زبان مورد نظر خود را انتخاب کنید',
  searchLanguages: 'جستجوی زبان‌ها...',
  autoDetect: 'تشخیص خودکار',
  noLanguagesFound: 'زبانی یافت نشد',
  askAnything: 'هر چیزی بپرسید',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'شخصی',
  freePlan: 'طرح رایگان',
  current: 'فعلی',
  close: 'بستن',
  archive: 'بایگانی',
  delete: 'حذف',
  confirmDelete: 'آیا مطمئن هستید که می‌خواهید این گفتگو را حذف کنید؟',
  confirmArchive: 'آیا مطمئن هستید که می‌خواهید این گفتگو را بایگانی کنید؟',
  deleteCannotUndo: 'این عمل قابل برگشت نیست.',
  archiveCanFind: 'می‌توانید آن را در فهرست بایگانی پس از بایگانی کردن پیدا کنید.',
  
  // 资源面板
  resources: 'منابع',
  addResource: 'افزودن منبع',
  deleteResource: 'حذف منبع',
  noMatchingResourcesFound: 'منبع مطابق یافت نشد',
  noResourcesAvailable: 'منبعی در دسترس نیست',
  hideResources: 'پنهان کردن منابع',
  showResources: 'نمایش منابع',
  
  // 聊天输入框
  typeMessage: 'پیام تایپ کنید...',
  thinkingOptions: 'گزینه‌های تفکر',
  deleteFile: 'حذف فایل',
  clearSelection: 'پاک کردن انتخاب',
  addAttachment: 'افزودن پیوست',
  sendMessage: 'ارسال پیام',
  
  // 思考模式选项
  deepInsight: 'بینش عمیق · تحلیل سطحی',
  deepInsightDesc: 'درک سریع نکات کلیدی',
  deepExploration: 'اکتشاف عمیق · تحلیل جامع',
  deepExplorationDesc: 'تحقیق عمیق چندبعدی',
  deepDeconstruction: 'تخریب عمیق · استدلال سیستماتیک',
  deepDeconstructionDesc: 'تحلیل پیشرونده لایه به لایه',
  
  // 写作模式选项
  contractReview: 'بررسی قرارداد · شناسایی ریسک',
  contractReviewDesc: 'تحلیل بندها و بررسی انطباق',
  textPolish: 'صیقل متن · بیان حرفه‌ای',
  textPolishDesc: 'بهینه‌سازی زبان و تنظیم ساختار',
  legalDocuments: 'اسناد حقوقی · پیش‌نویس استاندارد',
  legalDocumentsDesc: 'نگارش حرفه‌ای اسناد حقوقی',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ورود',
  register: 'ثبت نام',
  welcomeBack: 'به LawHelper خوش آمدید',
  loginSubtitle: 'دستیار تحقیقات حقوقی هوش مصنوعی شما',
  continueWithGoogle: 'ادامه با Google',
  continueWithMicrosoft: 'ادامه با Microsoft',
  continueWithWeChat: 'ادامه با WeChat',
  orContinueWith: 'یا ادامه با',
  emailTab: 'ایمیل',
  phoneTab: 'تلفن',
  emailPlaceholder: 'ایمیل خود را وارد کنید',
  phonePlaceholder: 'شماره تلفن را وارد کنید',
  codePlaceholder: 'کد ۶ رقمی را وارد کنید',
  sending: 'در حال ارسال...',
  verifying: 'در حال تأیید...',
  verify: 'تأیید',
  sendMagicLink: 'ارسال لینک جادویی',
  getVerificationCode: 'دریافت کد',
  resendCode: 'ارسال مجدد کد',
  resendIn: 'ارسال مجدد در',
  magicLinkSent: 'لینک جادویی به ایمیل شما ارسال شد',
  magicLinkHint: 'یک لینک امن به ایمیل شما ارسال خواهیم کرد',
  otpSent: 'کد تأیید ارسال شد',
  agreeToTerms: 'با ادامه دادن، شما موافقت می‌کنید با',
  privacyPolicy: 'سیاست حفظ حریم خصوصی',
  termsOfService: 'شرایط خدمات',
  and: 'و',
  privacyTitle: 'حریم خصوصی شما مهم است',
  privacyIntro: 'ما از کوکی‌ها و فناوری‌های مشابه برای ارائه بهترین تجربه استفاده می‌کنیم.',
  essentialCookies: 'کوکی‌های ضروری',
  essentialDesc: 'برای عملکرد وب‌سایت لازم است',
  analyticsCookies: 'کوکی‌های تحلیلی',
  analyticsDesc: 'به ما کمک می‌کند خدمات را بهبود دهیم',
  marketingCookies: 'کوکی‌های بازاریابی',
  marketingDesc: 'برای محتوای شخصی‌سازی شده استفاده می‌شود',
  acceptAll: 'پذیرش همه',
  essentialOnly: 'فقط ضروری',
  customize: 'سفارشی‌سازی',
  savePreferences: 'ذخیره تنظیمات',
  back: 'بازگشت',
  readPrivacyPolicy: 'سیاست حفظ حریم خصوصی ما را بخوانید',
  cookiePolicy: 'سیاست کوکی',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'بررسی AI',
  aiDraft: 'پیش‌نویس AI',
  smartAssistant: 'قالب',

  // 知识库搜索
  enableKnowledgeSearch: 'فعال‌سازی جستجو',
  knowledgeSearchDesc: 'AI در اسناد شما جستجو می‌کند',
  clickToDisable: 'غیرفعال',
  clickToEnable: 'فعال',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'بستن پنل منابع',
  uploading: 'در حال آپلود %{fileName}...',
  processing: 'در حال پردازش %{fileName}...',
  uploadSuccess: '✓ %{fileName} آپلود شد',
  uploadError: '✗ آپلود ناموفق: %{error}',
  quickAnswer: 'پاسخ سریع',
  quickAnswerDesc: 'پاسخ سریع به سوالات ساده',
  cancelRequest: 'لغو',
  library: 'کتابخانه',
  filterAll: 'همه',
  filterChat: 'گفتگوها',
  filterReview: 'بررسی',
  filterDraft: 'پیش‌نویس',
  filterTemplate: 'قالب',
  filterForm: 'فرم',
  thinking: 'در حال فکر کردن...',
  thinkingProcess: 'فرآیند تفکر',
  analyzingLegalLogic: 'تحلیل منطق حقوقی...',
  lawhelperThinking: 'Lawhelper در حال فکر کردن...',
  serviceError: 'خطای سرویس',
  uploaded: 'آپلود شده',
  settingsGeneral: 'عمومی',
  settingsNotifications: 'اعلان‌ها',
  settingsAppearance: 'ظاهر',
  settingsProfile: 'پروفایل',
  settingsResponseNotifications: 'اعلان‌های پاسخ',
  settingsResponseNotificationsDesc: 'اعلان هنگام تکمیل پاسخ هوش مصنوعی',
  settingsColorMode: 'حالت رنگ',
  settingsLight: 'روشن',
  settingsDark: 'تاریک',
  settingsSystem: 'سیستم',
  about: 'درباره',
  reviewTitle: 'بررسی سند',
  exitReview: 'خروج از بررسی',
  uploadPrompt: 'PDF را برای بررسی آپلود کنید',
  uploadButton: 'انتخاب فایل',
  startChatConfig: '"این سند را بررسی کن" را تایپ کنید',
  reviewPlaceholder: 'پیام بنویسید...',
  analyzing: 'در حال بررسی...',
  reviewComplete: 'بررسی تکمیل شد',
  issuesFound: '%{count} مشکل یافت شد',
  draftTitle: 'تنظیم سند حقوقی',
  draftPlaceholder: 'اینجا ویرایش کنید یا از هوش مصنوعی بخواهید...',
  analyzingTemplate: 'تحلیل قالب %{name}...',
  templateAnalyzed: '✅ قالب %{name} تحلیل شد!',
  templateAnalysisPrompt: 'تحلیل بندهای کلیدی',
  parsingFailed: '⚠️ تحلیل فایل ناموفق بود.',
  generating: 'در حال ایجاد...',
  generatedSuccess: '✅ سند ایجاد شد!',
  drafterWelcome: 'به دستیار اسناد هوش مصنوعی خوش آمدید',
  drafterYouCan: 'شما می‌توانید:',
  drafterUploadTemplate: 'قالب را برای تحلیل آپلود کنید',
  drafterDescribeNeeds: 'نیازهای سند را شرح دهید',
  drafterLetAiHelp: 'هوش مصنوعی در تنظیم قراردادها کمک می‌کند',
  drafterExamples: 'نمونه‌ها:',
  drafterExampleRental: '"یک قرارداد اجاره تنظیم کن"',
  drafterExampleLabor: '"قرارداد کار را تکمیل کن"',
  drafterInputPlaceholder: 'نیازهای خود را شرح دهید...',
  drafterThinking: 'در حال فکر کردن...',
  drafterHistoryTitle: 'تاریخچه',
  drafterNoHistory: 'تاریخچه‌ای وجود ندارد',
  drafterNewChat: 'گفتگوی جدید',
  drafterHistory: 'تاریخچه',
  drafterRemoveAttachment: 'حذف پیوست',
  drafterLineHeight: 'ارتفاع خط',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'خروجی Word (.docx)',
  drafterExportPdf: 'خروجی PDF',
  drafterSave: 'ذخیره سند',
  drafterDownload: 'دانلود سند',
  drafterUndo: 'بازگردانی',
  drafterRedo: 'تکرار',
  drafterBold: 'درشت',
  drafterItalic: 'مورب',
  drafterStrike: 'خط‌خورده',
  drafterUnderline: 'زیرخط',
  drafterHighlight: 'برجسته',
  drafterLink: 'درج پیوند',
  drafterAlignLeft: 'چپ‌چین',
  drafterAlignCenter: 'وسط‌چین',
  drafterAlignRight: 'راست‌چین',
  drafterAlignJustify: 'تراز',
  drafterList: 'فهرست',
  drafterBulletList: 'فهرست نقطه‌ای',
  drafterOrderedList: 'فهرست شماره‌دار',
  drafterTaskList: 'فهرست وظایف',
  drafterOpenResource: 'باز کردن منابع',
  drafterStopGeneration: 'توقف ایجاد',
  drafterAgentMode: 'حالت عامل فعال',
  drafterAgentModeOn: 'حالت عامل فعال',
  drafterAgentModeOff: 'حالت عادی',
  drafterUploadAttachment: 'آپلود پیوست',
  drafterExit: 'خروج',
  drafterConfirm: 'تأیید',
  drafterOpenLink: 'باز کردن پیوند',
  drafterDeleteLink: 'حذف پیوند',
  drafterQuote: 'نقل قول',
  workflowTitle: 'گردش کار هوش مصنوعی',
  workflowRunning: 'در حال اجرا...',
  workflowReady: 'آماده',
  workflowCompleted: 'تکمیل شد',
  workflowStartFailed: 'شروع گردش کار ناموفق',
  workflowExecutionFailed: 'اجرا ناموفق',
  workflowInterrupted: 'گردش کار متوقف شد',
  workflowProcessing: 'در حال پردازش...',
  workflowStepsCompleted: 'مرحله تکمیل شد',
  workflowStepsTotal: 'گردش کار تکمیل شد (%{count} مرحله)',
  acceptChanges: 'پذیرش تغییرات',
  rejectChanges: 'رد تغییرات',
  changesAccepted: 'تغییرات پذیرفته شد',
  changesRejected: 'تغییرات رد شد',
  stopWorkflow: 'توقف',
  restartWorkflow: 'شروع مجدد',
  startDrafting: 'شروع تنظیم',
  interrupt: 'توقف',
  documentSubject: 'موضوع سند *',
  documentType: 'نوع سند',
  jurisdiction: 'صلاحیت قضایی',
  specialRequirements: 'الزامات ویژه (اختیاری)',
  clickStartDrafting: '"شروع تنظیم" را کلیک کنید',
  docTypeContract: 'قرارداد',
  docTypeAgreement: 'توافق‌نامه',
  docTypeNotice: 'اطلاعیه',
  docTypeLetter: 'نامه',
  docTypePetition: 'دادخواست',
  docTypeWill: 'وصیت‌نامه',
  docTypePowerOfAttorney: 'وکالت‌نامه',
  countryChina: 'چین',
  countryUSA: 'ایالات متحده',
  countryGermany: 'آلمان',
  countryJapan: 'ژاپن',
  countryFrance: 'فرانسه',
  countryUK: 'بریتانیا',
  citationVerified: 'تأیید شده',
  citationUnverified: 'تأیید نشده',
  imageLoadFailed: 'بارگذاری تصویر ناموفق',
  smartDocTitle: 'دستیار اسناد هوشمند',
  smartDocChatTitle: 'دستیار اسناد هوش مصنوعی',
  smartDocDropPrompt: 'فایل PDF را اینجا رها کنید',
  smartDocSelectFile: 'انتخاب فایل',
  smartDocOr: 'یا',
  smartDocWelcomeTitle: 'به دستیار هوش مصنوعی خوش آمدید',
  smartDocWelcomeYouCan: 'شما می‌توانید:',
  smartDocUploadForAI: 'آپلود قالب',
  smartDocDescribeDoc: 'شرح نیازها',
  smartDocLetAIDraft: 'هوش مصنوعی در قراردادها کمک می‌کند',
  smartDocExamples: 'نمونه‌ها:',
  smartDocExampleRental: '"قرارداد اجاره تنظیم کن"',
  smartDocExampleLabor: '"قرارداد کار را تکمیل کن"',
  smartDocInputPlaceholder: 'نیازها را شرح دهید...',
  smartDocRemoveAttachment: 'حذف پیوست',
  smartDocOpenResources: 'باز کردن منابع',
  smartDocExit: 'خروج',
  reviewStartFailed: 'شروع بررسی ناموفق',
  reviewFailed: 'بررسی ناموفق',
  reviewFoundIssues: 'بررسی تکمیل شد، %{count} مشکل.',
  cannotReadStream: 'خواندن جریان ناممکن',
  parseEventFailed: 'تحلیل رویداد ناموفق',
  errorPrefix: 'خطا',
  unknownError: 'خطای ناشناخته',
  file: 'فایل',
  loading: 'در حال بارگذاری...',
  localFolders: 'پوشه‌های محلی',
  selectLocalFolder: 'انتخاب پوشه محلی',
  reselectFolder: 'تغییر پوشه',
  addToContext: 'افزودن به گفتگو',
  saveFile: 'ذخیره',
  renameFile: 'تغییر نام',
  fileSaved: 'فایل ذخیره شد',
  fileRenamed: 'فایل به %{name} تغییر نام یافت',
  browserNotSupported: 'مرورگر از دسترسی به پوشه پشتیبانی نمی‌کند',
  noFolderSelected: 'یک پوشه محلی انتخاب کنید',
  scanningFolder: 'اسکن پوشه...',
  selectFileToPreview: 'فایلی برای پیش‌نمایش انتخاب کنید',
  aiAnalyze: 'تحلیل هوش مصنوعی',
};
